import useProfiler from "../../../hooks/useProfiler";
import { createMicroConversionTrackingUtils } from "..";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getExtraProducts } from "../../../ancillaries/store/extraProducts/selectors";
import { getFlight } from "../../../store/flightDetails/selectors";

const utils = createMicroConversionTrackingUtils({
  name: "flights_web_condensed_extras_fd_mdot",
  stages: {
    fd: 1, // dummy stage
    fetchedFD: 2, // fully fetched flight details (fallback)
    main: 3, // FD where users see baggage and/or extras
    direct: 4,
    meta: 5,
    oneWay: 6,
    roundTrip: 7,
    solo: 8,
    nonSolo: 9
  },
  defaultStage: 1,
  mainStage: 3,
  goals: {},
  goalsWithValue: []
});

const useTrackStages = (isInViewport: boolean) => {
  const stages = utils.stages;
  const { isDirect, isOneWay, isRountrip, isSolo } = useProfiler();

  // Get access to flight details from the store
  const flight = useSelector(getFlight);
  const includedBaggage = flight?.ancillaries?.cabinBaggage || flight?.ancillaries?.checkedInBaggage;
  const extraProducts = useSelector(getExtraProducts);

  useEffect(() => {
    if (!includedBaggage && !extraProducts) {
      return;
    }

    if (!isInViewport) {
      return;
    }

    stages.main();
    isDirect() ? stages.direct() : stages.meta();
    isOneWay() && stages.oneWay();
    isRountrip() && stages.roundTrip();
    isSolo() ? stages.solo() : stages.nonSolo();
  }, [isDirect, isOneWay, isRountrip, isSolo, stages, isInViewport, includedBaggage, extraProducts]);
};
export default { ...utils, useTrackStages };
